export default __webpack_public_path__ + "static/media/inovacion.e80a4fa5.png";